<template>
  <div>
    <div v-if="soraRoomId==null">
      <h2>USER SELECT</h2>
      <div>
        <select v-model="selectedUserId" class="select">
          <option value>--</option>
          <option
            v-for="(value, index) in soraDataUsers"
            v-bind:key="index"
            v-bind:value="value.user_id"
          >{{ value.name }} [{{ value.modelType }}]</option>
        </select>
      </div>

      <h2>ROOM SELECT</h2>
      <div>
        <select v-model="selectedRoomId" class="select">
          <option value>--</option>
          <option
            v-for="(value, index) in soraDataRooms"
            v-bind:key="index"
            v-bind:value="value.room_id"
          >{{ value.name }} [{{ value.room_id }}]</option>
        </select>
      </div>
    </div>

    <h1>MEDIA SETTING</h1>
    <div>
      <div>CAMERA:</div>
      <select v-model="srcInputVideoId">
        <option
          v-for="src in srcInputVideoArray"
          v-bind:key="src.deviceId"
          v-bind:value="src.deviceId"
        >{{ src.label }}</option>
      </select>
    </div>
    <div>
      <div>解像度:</div>
      <select v-model="srcInputVideoResolution">
        <option
          v-for="src in srcInputVideoResolutionArray"
          v-bind:key="src.id"
          v-bind:value="src.id"
        >{{ src.label }}</option>
      </select>
      <p class="info">※対応してないカメラは他のものが選択されます</p>
    </div>
    <div>
      <div>AUDIO:</div>
      <select v-model="srcInputAudioId">
        <option
          v-for="src in srcInputAudioArray"
          v-bind:key="src.deviceId"
          v-bind:value="src.deviceId"
        >{{ src.label }}</option>
      </select>
    </div>
    <div v-if="soraCodec==null">
      <div>CODEC:</div>
      <select v-model="srcCodec">
        <option value="H264">H.264</option>
        <option value="VP8">VP8</option>
      </select>
    </div>
    <div v-if="soraRoomId==null">
      <video ref="videoPreview" class="settingVideo" onclick="this.play()" muted></video>
    </div>
    <div>
      <button class="button is-link" @click="sendSetting">接続</button>
    </div>
  </div>
  <!-- </div>
  </div>-->
</template>
<style scoped>
.info {
  color: white;
  font-size: 0.7em;
}
.settingVideo {
  margin-top: 10px;
  width: 150px;
}
.room {
  width: 100%;
  height: 4em;
}
.addroom {
  margin-top: 5px;
  margin-bottom: 5px;
  border: 1px solid white;
  padding: 10px;
}
</style>
<script>
import UserMedia from "@/api/usermedia";
import ServerAccess from "@/api/serveraccess";

export default {
  name: "VideoSetting",
  data() {
    return {
      soraDataUsers: [],
      soraDataRooms: [],
      srcInputVideoArray: [],
      srcInputAudioArray: [],
      srcInputVideoResolutionArray: [],
      srcInputVideoId: null,
      srcInputVideoResolution: null,
      srcInputAudioId: null,
      srcCodec: "VP8",
      selectedRoomId: "",
      selectedUserId: "",
      newRoomName: "DefaultName",
      newRoomId: Math.random()
        .toString(36)
        .slice(-6)
    };
  },
  props: [
    "soraData",
    "soraRoomId",
    "soraCodec",
    "soraCallRoomId",
    "updateTrigger"
  ],
  mounted() {
    if (this.$route.path == "/") return;

    // 最初に1度呼び出す

    let d = {};
    try {
      d = JSON.parse(localStorage.getItem("mediaSetting"));
      this.srcInputVideoId = d.video;
      this.srcInputVideoResolution = d.resolution;
      this.srcInputAudioId = d.audio;
      // this.srcCodec = d.codec;
    } catch (e) {}

    if (this.$refs.videoPreview) {
      let r = UserMedia.startGetusermedia({
        setting: d,
        targetDom: this.$refs.videoPreview,
        returnFunc: () => {
          let umd = UserMedia.getDevices();
          this.srcInputVideoArray = umd.videoinput;
          this.srcInputAudioArray = umd.audioinput;
          this.srcInputVideoResolutionArray = UserMedia.getResolutions();
        }
      });
    } else {
      let umd = UserMedia.getDevices();
      this.srcInputVideoArray = umd.videoinput;
      this.srcInputAudioArray = umd.audioinput;
      this.srcInputVideoResolutionArray = UserMedia.getResolutions();
    }

    this.soraDataUsers = this.soraData.users;
    this.soraDataRooms = this.soraData.rooms;

    this.selectedRoomId = this.soraRoomId != null ? this.soraRoomId : "";
    let isInRoomlist = false;
    for (let i in this.soraDataRooms) {
      if (this.soraDataRooms[i].room_id == this.selectedRoomId) {
        isInRoomlist = true;
      }
    }
    if (!isInRoomlist) {
      this.selectedRoomId = "";
    }
  },
  beforeDestroy() {
    if (
      this.$refs.videoPreview &&
      this.$refs.videoPreview.srcObject &&
      this.$refs.videoPreview.srcObject.getTracks()
    ) {
      for (const t of this.$refs.videoPreview.srcObject.getTracks()) {
        t.enabled = false;
        t.stop();
      }
      this.$refs.videoPreview.srcObject = null;
    }
  },
  methods: {
    async sendSetting() {
      // 両方が未選択か両方が選ばれていたら
      if (
        (this.selectedRoomId == "" && this.selectedUserId == "") ||
        (this.selectedRoomId != "" && this.selectedUserId != "")
      ) {
        alert("UserかRoomのどちらかのみ選択してください");
        return;
      }

      if (this.selectedUserId != "") {
        console.log("USER CALL " + this.selectedUserId);
        let resd = await ServerAccess.getSoraCall(
          this.soraData,
          this.selectedUserId
        );
        console.log(resd);
        if (!resd.data.room_id || resd.data.room_id == "") {
          alert("Userがログアウトした可能性があります。再度選択してください。");
          return;
        }
        this.selectedRoomId = resd.data.room_id;
      }

      if (!this.selectedRoomId) {
        alert("正しく処理できませんでした。再度選択してください。");
        return;
      }

      if (this.$refs.videoPreview && !this.$refs.videoPreview.srcObject) {
        alert("設定を確認してください。");
        return;
      }

      // if (this.$refs.videoPreview){
      if (
        this.srcInputVideoId &&
        this.srcInputVideoResolution &&
        this.srcInputAudioId
      ) {
        let d = {
          media: {
            video: this.srcInputVideoId,
            resolution: this.srcInputVideoResolution,
            audio: this.srcInputAudioId,
            codec: this.srcCodec
          }
        };

        d.room = {
          id: this.selectedRoomId
        };

        localStorage.setItem("mediaSetting", JSON.stringify(d.media));

        this.$emit("video-setting", d);
      }
      // }
    },
    updateSetting() {
      // データがアップデートしたらプレビューも更新
      let d = {
        video: this.srcInputVideoId,
        resolution: this.srcInputVideoResolution,
        audio: this.srcInputAudioId
      };
      UserMedia.startGetusermedia({
        setting: d,
        targetDom: this.$refs.videoPreview
      });
    }
  },
  watch: {
    srcInputVideoArray: function(newData, oldData) {
      let isNewVal = false;
      for (let i in newData) {
        if (newData[i].deviceId == this.srcInputVideoId) {
          isNewVal = true;
        }
      }

      if (!isNewVal && newData && newData.length > 0) {
        this.srcInputVideoId = newData[0].deviceId;
      }
    },
    srcInputAudioArray: function(newData, oldData) {
      let isNewVal = false;
      for (let i in newData) {
        if (newData[i].deviceId == this.srcInputAudioId) {
          isNewVal = true;
        }
      }

      if (!isNewVal && newData && newData.length > 0) {
        this.srcInputAudioId = newData[0].deviceId;
      }
    },
    srcInputVideoResolutionArray: function(newData, oldData) {
      if (
        this.srcInputVideoResolution == null &&
        newData &&
        newData.length > 0
      ) {
        this.srcInputVideoResolution =
          newData[Math.ceil(newData.length / 2) - 1].id;
      }
    },
    srcInputVideoId: function(newData, oldData) {
      this.updateSetting();
    },
    srcInputVideoResolution: function(newData, oldData) {
      this.updateSetting();
    },
    srcInputAudioId: function(newData, oldData) {
      this.updateSetting();
    },
    soraCallRoomId: function(newData, oldData) {
      console.log("WATCH soraCallRoomId " + newData);
      this.selectedUserId = "";
      this.selectedRoomId = newData;
      this.sendSetting();
    },
    updateTrigger: function(newData, oldData) {
      // 更新を走らせるための利用しないがインクリメントされた数値データによるイベント

      this.soraDataUsers = this.soraData.users;
      this.soraDataRooms = this.soraData.rooms;

      let isInUserlist = false;
      for (let i in this.soraDataUsers) {
        if (this.soraDataUsers[i].user_id == this.selectedUserId) {
          isInUserlist = true;
        }
      }
      if (!isInUserlist) {
        this.selectedUserId = "";
      }

      let isInRoomlist = false;
      for (let i in this.soraDataRooms) {
        if (this.soraDataRooms[i].room_id == this.selectedRoomId) {
          isInRoomlist = true;
        }
      }
      if (!isInRoomlist) {
        this.selectedRoomId = "";
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/VideoSetting.vue